const Reflection = {
  getClassName(obj) {
    let target = obj;
    if (!(target instanceof Function)) {
      target = obj.constructor;
    }
    return target.name;
  },

  evaluate(functionOrValue, context) {
    if (typeof functionOrValue === "function") {
      if (context) {
        return functionOrValue.call(context);
      } else {
        return functionOrValue();
      }
    } else {
      return functionOrValue;
    }
  },

  flatten(obj) {
    let ret = {};
    let separator = ".";
    /* eslint-disable guard-for-in */
    for (let key in obj) {
      let val = obj[key];
      if (val && val.constructor === Object && !_.isEmpty(val)) {
        // Recursion for embedded objects
        let obj2 = Reflection.flatten(val);
        for (let key2 in obj2) {
          let val2 = obj2[key2];
          ret[key + separator + key2] = val2;
        }
      } else {
        ret[key] = val;
      }
    }
    /* eslint-enable guard-for-in */
    return ret;
  },

  getNestedAttribute(obj, path, returnExists) {
    let fields = path.split(".");
    let result = obj || {};
    let i = 0;
    let numFields = fields.length;

    while (i < numFields) {
      if (returnExists && !_.has(result, fields[i])) {
        return false;
      }
      result = result[fields[i]];
      if (!result && i < numFields - 1) {
        result = {};
      }
      if (typeof result === "undefined") {
        if (returnExists) {
          return true;
        }
        return result;
      }
      i++;
    }
    if (returnExists) {
      return true;
    }
    return result;
  },
};

export default Reflection;



// WEBPACK FOOTER //
// ./src/framework/reflection.js